// extracted by mini-css-extract-plugin
module.exports = {"root":"meta-list_root__jhGoC","onlyMobile":"meta-list_onlyMobile___WeOW","item":"meta-list_item__e_3Kj","link":"meta-list_link__mRfet"};